import classNames from 'classnames';
import { useState } from 'react';
import { Image } from 'tdesign-react';

import { EditorAddAudio } from '@/components/icon';
import { RenameType, UserResourceType } from '@/interface/library';
import { CgiErrorCode } from '@/services/cgi';
import { UserResourceDetail } from '@/services/library';
import { useAppDispatch } from '@/store';
import { changeId } from '@/store/modules/library';

import Rename from '../rename';
import LibraryAudioViewer from '../review/audio';
import { NameLength } from './image';
import styles from './index.module.less';

interface IProps {
  value: UserResourceDetail;
  type: UserResourceType | undefined;
  index: number;
  url: string;
  resourceName: string;
  checked: boolean;
  disabled: boolean;
  handleCheckedChange: (check: boolean) => void;
  updateResource: (value: UserResourceDetail) => void;
  reNameCallback: (info: UserResourceDetail) => void
}
const AudioItem: React.FC<IProps> = (props) => {
  const {
    type, url,
    resourceName, checked, index,
    value, disabled,
    handleCheckedChange,
    reNameCallback,
  } = props;

  const dispatch = useAppDispatch();

  const spliceName = resourceName.slice(0, NameLength);
  const name = resourceName?.length > NameLength ? `${spliceName}...` : spliceName;
  const [visible, setVisible] = useState(false);

  const changeVisible = (vi: boolean) => {
    if (vi) {
      dispatch(changeId({ id: value.resourceId }));
    }
    setVisible(vi);
  };

  const handleStopPropagation = (e: React.MouseEvent) => {
    e.stopPropagation();
  };

  const reName = (code: CgiErrorCode, info: {
    name: string, id: string
  }) => {
    if (code === CgiErrorCode.NO_ERROR) {
      reNameCallback({ ...value, resourceName: info.name });
    }
  };
  return (
    <div className={classNames(styles.item, {
      [styles.checked]: checked,
    })}>
      <LibraryAudioViewer
        type={type}
        images={[]}
        defaultIndex={index}
        checked={checked}
        url={url}
        onCheckedChange={check => handleCheckedChange(check)}
      >
        <div className={styles.content}>
          <Image
            src={
              '//nova.file.video.qpic.cn/uploadFile/5357668b9079148aefc2bb2660ead58a.png'
            }
            style={{ width: 68, height: 120 }}
            fit="contain"
            loading="加载中"
          />
        </div>
      </LibraryAudioViewer>
      <div className={styles.fileName} onClick={handleStopPropagation}>
        {
          visible
            ? <Rename
              resourceName={resourceName}
              type={RenameType.TYPE_RENAME_RESOURCE}
              id={value.resourceId || ''}
              visible={visible}
              callBack={reName}
              changeVisible={changeVisible}
            /> : <>
              <EditorAddAudio /><span className={styles.name}>{name}</span>
              {
                disabled ? null : <span className={styles.edit}>
                  <Rename
                    resourceName={resourceName}
                    type={RenameType.TYPE_RENAME_RESOURCE}
                    id={value.resourceId || ''}
                    visible={visible}
                    changeVisible={changeVisible}
                  />
                </span>
              }
            </>
        }
      </div>
    </div>
  );
};

export default AudioItem;
